const styles = (theme) => ({
  parent: {
    position: 'relative',
  },
  maxWidth: {
    width: '100%',
  },
  shown: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
    backgroundColor: 'rgb(255, 255, 255)',
  },
  progress: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    marginLeft: -25,
    marginTop: -25,
    '&:focus': {
      border: 'none',
      outline: 'none',
    },
  },
  hidden: {
    display: 'none',
  },
  errorIcon: {
    fontSize: '2.5rem',
  },
  helpIcon: {
    fontSize: '2.5rem',
    color: theme.palette.primary.dark,
  },
});

export default styles;
